export function resolveLanguage<T extends string>(
  clientLanguages: readonly string[],
  appLanguages: T[],
  fallbackAppLanguage: T
): T {
  for (const clientLang of clientLanguages) {
    const appLanguage = appLanguages.find((lang) => lang === clientLang)
    if (appLanguage !== undefined) {
      return appLanguage
    }
  }

  return fallbackAppLanguage
}
